import $ from 'static/script/libs/jquery';
import defineComponent from 'flight';

function CartPayPalPayment() {
    this.after('initialize', function () {
        function swaplinks() {
            $('#btnBuyPayPal').show();
            $('#refreshlink').hide();
        }

        function triggerLink() {
            let el = document.getElementById('triggerButton');
            el.onclick();
        }

        let isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
        if (isSafari) {
            swaplinks();
        }
        triggerLink();
    });
}

module.exports =  defineComponent.component(CartPayPalPayment);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/cart-paypal-payment-ui.js